const KEY_IDX = {
  37: 'LEFT',
  38: 'UP',
  39: 'RIGHT',
  40: 'DOWN'
};

export {
  KEY_IDX
};



// WEBPACK FOOTER //
// ./lib/utils/renderUtils.js